
        var result = require("!!../../../../node_modules/css-loader/index.js!./branches-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/branches/branches-list/branches-list.component.css
// module id = 2510
// module chunks = 1